<div mat-dialog-content class="content">

<h4>{{data.title}}</h4>
<hr>
<span class="small">{{data.content}}</span>

</div>

<div mat-dialog-actions align="end">

  <button mat-button (click)="confirm()">Sim</button>&nbsp;
  <button mat-button (click)="onNoClick()">Não</button>

</div>